import { Restore } from '@mui/icons-material'
import { Button, Stack } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import OrderButton from './OrderButton'
import ShareButton from './ShareButton'

function PreviewButtons({ shareDescription, generateShareUrl, svgRef, filename, resetColors }) {

    return (<>
        <Stack direction="row" sx={{ mt: 2 }} textAlign="center" gap={2}>
            <Button variant="contained" color="secondary" startIcon={<Restore />}
                id="reset-button"
                onClick={() => {
                    resetColors();
                }}
            >
                Reset Pockets
            </Button>

            <ShareButton shareDescription={shareDescription} generateShareUrl={generateShareUrl} svgRef={svgRef} filename={filename} />

            <OrderButton generateShareUrl={generateShareUrl} />
        </Stack>
    </>)
}

PreviewButtons.propTypes = {
    resetColors: PropTypes.func.isRequired,
    shareDescription: PropTypes.string.isRequired,
    generateShareUrl: PropTypes.func.isRequired,
    svgRef: PropTypes.object.isRequired,
    filename: PropTypes.string.isRequired,
}

export default PreviewButtons